import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total:0 , error: "", message: "" }


export const getAllStoreVoucherAction = createAsyncThunk(
    'get-all-Vouchers',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/stores?page=${data?.page}&limit=${data?.limit}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAllStoreVoucherSlice = createSlice({
    name: 'get-all-Vouchers',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllStoreVoucherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAllStoreVoucherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total= action.payload.totalData
            })
            builder.addCase(getAllStoreVoucherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getAllStoreVoucherReducer = getAllStoreVoucherSlice.reducer